import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Wrapper from '../../elements/wrapper';

import Star from '../../../images/icons/star.inline.svg';
import { TransitionMixin, media } from '../../helpers';

const CurrentReviewsContainer = styled.div`
    .review-title-container {
        text-align: center;
        ${media.large`max-width: 70vw;`}
        > .inner-wrap {
            padding: 40px 0;
            border-top: 2px solid #000;
            border-bottom: 2px solid #000;

            .stars-container {
                display: flex;
                justify-content: center;
                margin-bottom: 10px;

                .star {
                    margin-right: 5px;
                    &:last-child {
                        margin-right: 0px;
                    }
                    svg {
                        height: 30px;
                        width: 30px;
                    }
                }
            }
            h3 {
                margin: 0 0 20px;
                font-size: 1.6rem;
                color: #000;
            }

            button {
                background-color: #f74d33;
                color: #fff;
                border: 1px solid #f74d33;
                font-weight: bold;
                border-radius: 5px;
                padding: 5px 0;
                max-width: 150px;
                width: 100%;

                &:hover {
                    background-color: transparent;
                    color: #f74d33;
                }
            }
        }

        &.with-reviews {
            > .inner-wrap > p {
                margin: 0;
                font-weight: bold;
                font-size: 1rem;
                color: #000;
            }

            .btn-container {
                padding-top: 20px;
                text-align: center;
                ${media.large`text-align: left;`}
                button {
                    background-color: #f74d33;
                    color: #fff;
                    border: 1px solid #f74d33;
                    font-weight: bold;
                    border-radius: 5px;
                    padding: 5px 0;
                    max-width: 120px;
                    width: 100%;
                    ${TransitionMixin('.25s')};

                    &:hover {
                        background-color: transparent;
                        color: #f74d33;
                    }
                }
            }

            .current-reviews-container {
                padding-top: 70px;
                ${media.large`max-width: 65vw;`}
                .item-container {
                    margin-bottom: 70px;
                    &:last-child {
                        margin-bottom: 0px;
                    }
                    .inner-wrap {
                        text-align: left;
                        ${media.large`display: flex;align-items: center;`}
                        .reviewer-container {
                            flex: 1;
                            margin-bottom: 30px;
                            ${media.large`margin-bottom: 0px;`}
                            p {
                                &.date {
                                    font-size: 0.82rem;
                                    color: #b2b2b2;
                                    margin: 0 0 10px;
                                }
                            }

                            h4 {
                                margin-bottom: 10px;
                            }

                            .stars {
                                display: flex;
                                margin-right: 3px;

                                svg {
                                    height: 18px;
                                    width: 18px;
                                }
                            }
                        }
                        .review-body-container {
                            flex: 3;
                            h4 {
                                margin-bottom: 10px;
                            }

                            p {
                                &:last-child {
                                    margin-bottom: 0px;
                                }
                            }
                        }
                    }
                }
            }
            .pagination-container {
                padding-top: 60px;
                ul {
                    padding: 0;
                    margin: 0;
                    list-style: none;

                    li {
                        margin-right: 15px;
                        display: inline-block;

                        &:last-child {
                            margin-right: 0px;
                        }

                        button {
                            color: #f74d33;
                            background-color: transparent;
                            border: none;
                            padding: 0;
                            font-weight: bold;
                            font-size: 1rem;

                            &:hover,
                            &.active {
                                opacity: 0.7;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const CurrentReviews = ({ setIsModalShowing, reviews }) => {
    const [reviewTitle, setReviewTitle] = useState('');
    const [reviewCaption, setReviewCaption] = useState('');
    const [paginationIndex, setPagination] = useState(0);
    const [reviewPages, setReviewPages] = useState(0);
    const [currentPagNum, setCurrentPagNum] = useState(0);

    const doesProductHaveReviews = reviews && reviews.length > 0;

    function handlePag(num) {
        let newIndex = (num - 1) * 4;
        setPagination(newIndex);
        setCurrentPagNum(num);
    }

    function getPagination() {
        // get number of pages

        let pages = [];
        let x = Math.ceil(reviews.length / 4);
        console.log('x', x);

        for (let i = 0; i < x; i++) {
            pages.push(i + 1);
        }
        setReviewPages(pages);
    }

    function generateStarStats() {
        // set title
        if (doesProductHaveReviews) {
            let allStarRatings = 0;
            let starAvg;

            reviews.map((reviewNode) => {
                let review = reviewNode.node;
                allStarRatings = allStarRatings + review.stars;
            });

            starAvg = allStarRatings / reviews.length;

            if (starAvg > 4) {
                setReviewTitle('Excellent');
            } else if (starAvg < 2) {
                setReviewTitle('Eh');
            } else if (starAvg < 3) {
                setReviewTitle('Decent');
            } else if (starAvg < 4) {
                setReviewTitle('Good');
            }

            setReviewCaption(
                `${starAvg} average based on ${reviews.length} reviews.`
            );
        } else {
            setReviewTitle('No reviews yet');
            return;
        }
    }

    useEffect(() => {
        generateStarStats();

        if (reviews && reviews.length > 0) {
            getPagination();
        }
    }, []);

    return (
        <CurrentReviewsContainer>
            {doesProductHaveReviews ? (
                <>
                    <Wrapper className="review-title-container with-reviews">
                        <Wrapper className="inner-wrap">
                            <div className="stars-container">
                                <div className="star">
                                    <Star />
                                </div>
                                <div className="star">
                                    <Star />
                                </div>
                                <div className="star">
                                    <Star />
                                </div>
                                <div className="star">
                                    <Star />
                                </div>
                                <div className="star">
                                    <Star />
                                </div>
                            </div>
                            <h3>{reviewTitle}</h3>
                            <p>{reviewCaption}</p>
                        </Wrapper>
                        <Wrapper className="btn-container">
                            <button onClick={() => setIsModalShowing(true)}>
                                Write a review
                            </button>
                        </Wrapper>
                        <Wrapper className="current-reviews-container">
                            {reviews &&
                                reviews
                                    .slice(paginationIndex, paginationIndex + 4)
                                    .map((reviewNode, index) => {
                                        const review = reviewNode.node;
                                        const {
                                            reviewbody,
                                            reviewtitle,
                                            email,
                                            reviewername,
                                            producthandle,
                                            date,
                                        } = review || {};

                                        let stars = [];
                                        for (let i = 0; i < review.stars; i++) {
                                            stars.push(i);
                                        }

                                        return (
                                            <div
                                                className="item-container"
                                                key={index}
                                            >
                                                <div className="inner-wrap">
                                                    <div className="reviewer-container">
                                                        <p className="date">
                                                            {date}
                                                        </p>
                                                        <h4 className="name">
                                                            {reviewername}
                                                        </h4>
                                                        <div className="stars">
                                                            {stars.map(() => {
                                                                return (
                                                                    <div className="star">
                                                                        <Star />
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                    <div className="review-body-container">
                                                        <h4>{reviewtitle}</h4>
                                                        <p>{reviewbody}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                        </Wrapper>
                        <Wrapper className="pagination-container">
                            <div className="inner-wrap">
                                <ul>
                                    {reviewPages &&
                                        reviewPages.map((pageNum, index) => {
                                            return (
                                                <li>
                                                    <button
                                                        className={
                                                            currentPagNum ===
                                                            index + 1
                                                                ? 'active'
                                                                : ''
                                                        }
                                                        onClick={() =>
                                                            handlePag(pageNum)
                                                        }
                                                    >
                                                        {pageNum}
                                                    </button>
                                                </li>
                                            );
                                        })}
                                </ul>
                            </div>
                        </Wrapper>
                    </Wrapper>
                </>
            ) : (
                <Wrapper className="review-title-container no-reviews">
                    <Wrapper className="inner-wrap">
                        <div className="stars-container">
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>
                            <div className="star">
                                <Star />
                            </div>
                        </div>
                        <h3>{reviewTitle}</h3>
                        <button onClick={() => setIsModalShowing(true)}>
                            Be the first
                        </button>
                    </Wrapper>
                </Wrapper>
            )}
        </CurrentReviewsContainer>
    );
};

export default CurrentReviews;
